//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'd2-card',
  props: {
    height: {
      type: String,
      default: '',
      required: false
    }
  },
  computed: {
    cardBodyStyle: function cardBodyStyle() {
      return {
        marginTop: '-10px',
        marginBottom: '-10px',
        marginLeft: '-10px',
        marginRight: '-20px'
      };
    },
    scrollInnerStyle: function scrollInnerStyle() {
      return {
        marginRight: '10px'
      };
    }
  }
};